import { useCallback, useState } from 'react';

import { CommandLifecycle } from '@coinweb/webapp-library';
import { v4 } from 'uuid';

import type { CoinwebWalletMessage } from '../types';

export const useWalletLifecycleMessages = (messageOverrides?: { [K in CommandLifecycle]?: string }) => {
  const [message, setMessage] = useState<CoinwebWalletMessage | null>(null);

  const generateMessage = useCallback((lifecycle: CommandLifecycle, id?: string) => {
    const map: Record<CommandLifecycle, string> = {
      [CommandLifecycle.Initiated]: 'QR code scanned',
      [CommandLifecycle.Pending]: 'Waiting for approval...',
      [CommandLifecycle.Updated]: 'Request update received',
      [CommandLifecycle.Confirmed]: 'Connection approved',
      [CommandLifecycle.Cancelled]: 'Request was cancelled',
      [CommandLifecycle.Failed]: 'Request failed',
      ...messageOverrides,
    };
    setMessage({
      id: id || v4(),
      message: map[lifecycle],
      type: lifecycle,
    });
  }, []);

  return {
    message,
    generateMessage,
    clearMessage: () => setMessage(null),
  };
};
